export default function PageLoader() {
  return (
    <div className="flex items-center justify-center w-full h-full min-h-80">
      <svg
        className="block overflow-visible"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Track */}
        <circle cx="24" cy="24" r="20" stroke="rgba(232, 224, 212, 0.07)" strokeWidth="2" />
        {/* Spinning arc */}
        <circle
          style={{ transformOrigin: '24px 24px' }}
          className="animate-loader-spin"
          cx="24"
          cy="24"
          r="20"
          stroke="#c8963e"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="32 95"
        />
        {/* Inner track */}
        <circle cx="24" cy="24" r="12" stroke="rgba(232, 224, 212, 0.05)" strokeWidth="1.5" />
        {/* Counter arc */}
        <circle
          style={{ transformOrigin: '24px 24px' }}
          className="animate-loader-spin-reverse"
          cx="24"
          cy="24"
          r="12"
          stroke="rgba(200, 150, 62, 0.4)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDasharray="12 63"
        />
      </svg>
    </div>
  );
}
